import { FC, useMemo } from "react";
import channelCover from './ChannelCover.jpg';
import { ChannelNamContainer } from "./styles";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useAutoChannelName } from "../hooks/useAutoChannelName";
import { LMSCourseTypes } from "shared/pages/teams/const/LMSCourseTypes";
import { TeamHolder } from "shared/components/TeamCard/TeamHolder";
import { getDefaultChannelCover } from "shared/pages/teams/components/support/getDefaultChannelCover";
import { useTranslation } from "react-i18next";
import { FlexBox } from "@brg/ui";

export const ChannelDefaultEmblem: FC<{team: any}> = ({ team }) => {
    const { t, i18n: { language } } = useTranslation()
    const { isChannel, channelType} = isTeamChannel(team?.moderationType);

    const autoChannelName = useAutoChannelName(team, !isChannel)

    const calcCoverBg = useMemo(() => {
        return team && getDefaultChannelCover(team?.additionalInfo?.lmsCourseType)
    } , [team])

    const calcCourseType= useMemo(() => {
        const type = team && team?.additionalInfo?.lmsCourseModuleFormat
        return t(`autochannels.cover.course_type_${type}`)
    } , [team, language])

    const calcLmsType= useMemo(() => {
        const type = team && team?.additionalInfo?.lmsCourseType
        return t(`autochannels.cover.type_${type}`)
    } , [team, language])

    const cover = useMemo(() => {
        if (channelType === ModerationType.Channel) {
            return <TeamHolder team={team}/>
        } else if (channelType === ModerationType.ChannelGroupOrCourse) {
            return (
                <ChannelNamContainer bg={calcCoverBg}>
                    <FlexBox direction="column">
                        <span className="course-lms_type">{calcLmsType}</span>
                        <span className="course-name">{team?.name}</span>
                        <span className="course-type">{calcCourseType}</span>
                    </FlexBox>
                </ChannelNamContainer>
            )
        }
        return <TeamHolder team={team}/>
    } , [autoChannelName, calcCoverBg, channelType, calcLmsType, calcCourseType, language])

    return cover
}import { FC, useMemo } from "react";
import channelCover from './ChannelCover.jpg';
import { ChannelNamContainer } from "./styles";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useAutoChannelName } from "../hooks/useAutoChannelName";
import { LMSCourseTypes } from "shared/pages/teams/const/LMSCourseTypes";
import { TeamHolder } from "shared/components/TeamCard/TeamHolder";
import { getDefaultChannelCover } from "shared/pages/teams/components/support/getDefaultChannelCover";
import { useTranslation } from "react-i18next";
import { FlexBox } from "@brg/ui";

export const ChannelDefaultEmblem: FC<{team: any}> = ({ team }) => {
    const { t, i18n: { language } } = useTranslation()
    const { isChannel, channelType} = isTeamChannel(team?.moderationType);

    const autoChannelName = useAutoChannelName(team, !isChannel)

    const calcCoverBg = useMemo(() => {
        return team && getDefaultChannelCover(team?.additionalInfo?.lmsCourseType)
    } , [team])

    const calcCourseType= useMemo(() => {
        const type = team && team?.additionalInfo?.lmsCourseModuleFormat
        return t(`autochannels.cover.course_type_${type}`)
    } , [team, language])

    const calcLmsType= useMemo(() => {
        const type = team && team?.additionalInfo?.lmsCourseType
        return t(`autochannels.cover.type_${type}`)
    } , [team, language])

    const cover = useMemo(() => {
        if (channelType === ModerationType.Channel) {
            return <TeamHolder team={team}/>
        } else if (channelType === ModerationType.ChannelGroupOrCourse) {
            return (
                <ChannelNamContainer bg={calcCoverBg}>
                    <FlexBox direction="column">
                        <span className="course-lms_type">{calcLmsType}</span>
                        <span className="course-name">{team?.name}</span>
                        <span className="course-type">{calcCourseType}</span>
                    </FlexBox>
                </ChannelNamContainer>
            )
        }
        return <TeamHolder team={team}/>
    } , [autoChannelName, calcCoverBg, channelType, calcLmsType, calcCourseType, language])

    return cover
}